import { connect } from 'react-redux';

import { Pagination, PaginationPropTypes } from 'src/components/pagination';
import {
  getIsBranchListLoading,
  getIsBranchListError,
  getBranchesPagination,
} from 'src/redux/branches';
import { CustomPaginationPropTypes } from 'src/types/pagination';
import { BucketState } from 'src/types/state';

type Props = Partial<PaginationPropTypes> & CustomPaginationPropTypes;

const mapStateToProps = (state: BucketState, ownProps: Props) => {
  const isLoading = getIsBranchListLoading(state);
  const isError = getIsBranchListError(state);
  const pages = getBranchesPagination(state)(ownProps.getPaginationUrl);

  return {
    isLoading,
    pages,
    isError,
    uiEventSource: 'branchesScreen',
    uiEventSubjectId: 'branchesPagination',
  };
};

export default connect(mapStateToProps)(Pagination);
